import * as ngCommon from "@angular/common";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ModalModule } from "ngx-bootstrap";

import { UtilsModule } from "@shared/utils/utils.module";
import { AbpModule } from "@abp/abp.module";
import { CommonModule } from "@shared/common/common.module";

import { TimeZoneComboComponent } from "./timing/timezone-combo.component";
import { AppAuthService } from "./auth/app-auth.service";
import { JqPluginDirective } from "./libs/jq-plugin.directive";
import { CommonLookupModalComponent } from "./lookup/common-lookup-modal.component";
import { DateRangePickerComponent } from "./timing/date-range-picker.component";
import { DatePickerDirective } from "./timing/date-picker.component";
import { AppRouteGuard } from "./auth/auth-route-guard";
import { DateTimeService } from "./timing/date-time.service";
import { AppLocalizationService } from "@app/shared/common/localization/app-localization.service";
import { AppNavigationService } from "@app/shared/layout/nav/app-navigation.service";
import { InputMaskModule } from "primeng/primeng";
import { DataTableModule } from "primeng/primeng";
import { PaginatorModule } from "primeng/primeng";
import { EmailsComponent } from "./emails/emails.component";
import { PhonesComponent } from "./phones/phones.component";
import { AddressesComponent } from "./addresses/addresses/addresses.component";
import { AddressComponent } from "@app/shared/common/addresses/address/address.component";
import { SelectLanguageComponent } from "./localization/select-language/select-language.component";

@NgModule({
    imports: [
        ngCommon.CommonModule,
        FormsModule,
        ModalModule.forRoot(),
        UtilsModule,
        AbpModule,
        CommonModule,
        DataTableModule,
        PaginatorModule,
        InputMaskModule,
    ],
    declarations: [
        TimeZoneComboComponent,
        JqPluginDirective,
        CommonLookupModalComponent,
        DateRangePickerComponent,
        DatePickerDirective,
        EmailsComponent,
        PhonesComponent,
        AddressesComponent,
        AddressComponent,
        SelectLanguageComponent,
    ],
    exports: [
        TimeZoneComboComponent,
        JqPluginDirective,
        CommonLookupModalComponent,
        DateRangePickerComponent,
        DatePickerDirective,
        EmailsComponent,
        PhonesComponent,
        AddressesComponent,
        AddressComponent,
        SelectLanguageComponent,
    ],
    providers: [DateTimeService, AppLocalizationService, AppNavigationService],
})
export class AppCommonModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AppCommonModule,
            providers: [AppAuthService, AppRouteGuard],
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/app-common.module.ts